import React from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import './About.css';
import ceoImage from '../assets/ceo.jpg';
import logo from '../assets/SamsoftixLogo.jpg';

function About() {
  const navigate = useNavigate();

  const handleInternsClick = () => {
    navigate('/interns');
  };

  return (
    <div className="about-page">
      {/* ✅ SEO Meta Tags */}
      <Helmet>
        <title>About SamSoftix | Leading Software, AI & Training Company in Pakistan</title>
        <meta
          name="description"
          content="SamSoftix is a leading software development company in Pakistan with offices in Wan, Sambrial. We specialize in web, mobile, and AI solutions and offer internships and remote coding training programs."
        />
        <meta
          name="keywords"
          content="SamSoftix, Software Development Company Pakistan, Web Development, Mobile Apps, Game Development, AI Solutions, Internships Pakistan, Coding Training, Qasim Mehmood Cheema"
        />
        <link rel="canonical" href="https://www.samsoftix.com/about" />

        {/* ✅ Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "SamSoftix",
            url: "https://www.samsoftix.com",
            logo: "https://www.samsoftix.com/assets/SamsoftixLogo.jpg",
            description:
              "SamSoftix provides professional web, mobile, game, and AI development services, plus remote and on-site training programs. Offices in Wan, Sambrial, Pakistan.",
            founder: {
              "@type": "Person",
              name: "Qasim Mehmood Cheema",
              jobTitle: "Founder & CEO",
              alumniOf: "Gift University, Gujranwala",
            },
            address: [
              {
                "@type": "PostalAddress",
                addressLocality: "Wan",
                addressRegion: "Punjab",
                addressCountry: "Pakistan",
              },
              {
                "@type": "PostalAddress",
                addressLocality: "Sambrial",
                addressRegion: "Punjab",
                addressCountry: "Pakistan",
              },
            ],
            sameAs: [
              "https://www.facebook.com/samsoftix",
              "https://www.linkedin.com/company/samsoftix",
              "https://twitter.com/samsoftix",
            ],
          })}
        </script>
      </Helmet>

      {/* ✅ Hero Section */}
      <section className="about-hero">
        <img src={logo} alt="SamSoftix Logo" className="about-logo" />
        <h1>
          About <span className="highlight">SamSoftix</span>  Software, AI & Training Company
        </h1>

        <p>
          <strong>SamSoftix</strong> is a trusted software development company in Pakistan, delivering
          <strong> web, mobile, game, and AI solutions</strong> to clients worldwide. With offices in
          <strong> Wan and Sambrial</strong>, we combine technology, creativity, and industry expertise
          to help businesses grow, automate, and modernize their digital presence.
        </p>

        <p>
          Beyond development, we are committed to nurturing the next generation of tech professionals.
          Our <strong>remote and on-site training programs</strong> provide hands-on experience in
          coding, AI, app development, and real-world software engineering practices.
        </p>

        <p>
          Our team of <strong>experienced developers, designers, and AI specialists</strong> ensures
          every project meets international standards and delivers measurable, real-world results
          for businesses and learners alike.
        </p>

      </section>

      {/* ✅ Vision & Mission */}
      <section className="about-values">
        <div className="value-card">
          <h2>Our Vision</h2>
          <p>
            Our vision is to become Pakistan’s most trusted <strong>technology partner</strong> and a recognized global leader in
            <strong> software innovation, AI solutions, and digital education</strong>, empowering businesses and learners through modern, impactful technology.
          </p>


        </div>

        <div className="value-card">
          <h2>Our Mission</h2>
          <p>
            Our mission is to deliver <strong>professional web, mobile app, game, and AI development services</strong>
            to startups, businesses, and organizations in Pakistan and worldwide. We focus on building
            <strong>scalable, secure, and performance-driven digital solutions</strong> while providing
            <strong>practical remote and on-site training programs</strong> that prepare students and interns
            for real industry work.
          </p>
          <p>
            Through innovation, mentorship, and real project experience, SamSoftix aims to bridge the gap
            between <strong>technology, business growth, and digital education</strong>.
          </p>

        </div>

        <div className="value-card">
          <h2>Internships & Training</h2>
          <p>
            At SamSoftix, we offer hands-on <strong>internships and training programs</strong> in Web Development, Mobile Apps, Game Development, and AI/ML.
            Our programs are designed to provide learners with real-world experience, industry exposure, and expert mentorship,
            equipping them with the skills needed to launch successful careers in technology.
          </p>
          <button className="interns-btn" onClick={handleInternsClick}>
            Explore Internship Programs
          </button>

        </div>
      </section>

      {/* ✅ CEO Section */}
      <section className="ceo-section">
        <h2>Meet Our Founder & CEO</h2>
        <div className="ceo-card">
          <img src={ceoImage} alt="Qasim Mehmood Cheema - CEO SamSoftix" />
          <div className="ceo-info">
            <h3>Qasim Mehmood Cheema</h3>

            <p><strong>Head Office:</strong> Wan, Punjab, Pakistan</p>
            <p>
              Qasim Mehmood Cheema is the <strong>Founder and CEO of SamSoftix</strong>, a leading professional software house in Pakistan, delivering world-class
              <strong> web, mobile, game, and AI solutions</strong> to clients locally and globally. With a strong focus on innovation, quality, and client satisfaction,
              he ensures that every project meets international standards and business objectives.
            </p>
            <p>
              Under his guidance, SamSoftix has successfully served <strong>startups, SMEs, and enterprise clients</strong>, providing scalable, secure, and performance-driven digital solutions.
              Qasim also leads our <strong>training and internship programs</strong>, mentoring aspiring developers to bridge the gap between education and industry-ready skills.
            </p>
            <p>
              His commitment to excellence, cutting-edge technology, and impactful education has established SamSoftix as a <strong>trusted technology partner</strong> in Pakistan and beyond.
            </p>
          </div>
        </div>
      </section>

      {/* ✅ CTA Section */}
      <section className="offer-cta">
        <h2>Let’s Build the Future Together 🚀</h2>
        <p>
          Whether you’re looking for a <strong>website, mobile app, game, AI solution</strong>,
          or want to <strong>learn coding and AI</strong>, SamSoftix is your trusted partner for ,
          growth, innovation, and practical learning.
        </p>
        <button className="cta-btn" onClick={() => navigate('/contact')}>
          Contact Us Today
        </button>
      </section>
    </div>
  );
}

export default About;
